var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8991 6.8968C13.2634 6.55861 13.7936 6.46762 14.2492 6.66608C14.705 6.86481 15 7.31516 15 7.81232V22.1873C15 22.6845 14.705 23.1348 14.2492 23.3335C13.7936 23.532 13.2634 23.441 12.8991 23.1029L8.88427 19.3748H6.25C4.86929 19.3748 3.75 18.2555 3.75 16.8748V13.1248C3.75 11.7441 4.86929 10.6248 6.25 10.6248H8.88427L12.8991 6.8968ZM25.0537 10.6785C25.5419 10.1904 26.3331 10.1904 26.8213 10.6785C27.3094 11.1667 27.3094 11.958 26.8213 12.4461L24.2676 14.9998L26.8213 17.5535C27.3094 18.0416 27.3094 18.833 26.8213 19.3211C26.3331 19.8093 25.5419 19.8091 25.0537 19.3211L22.5 16.7674L19.9462 19.3211C19.4581 19.8093 18.6669 19.8091 18.1788 19.3211C17.6906 18.8329 17.6906 18.0416 18.1788 17.5535L20.7324 14.9998L18.1788 12.4461C17.6906 11.9579 17.6906 11.1667 18.1788 10.6785C18.6669 10.1904 19.4581 10.1904 19.9462 10.6785L22.5 13.2323L25.0537 10.6785Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.633093460ca036e6668ff73ad56fd418.svg";
export { ForwardRef as ReactComponent };